import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck } from "lucide-react";
import { fmtRelative } from "@/lib/format";
import EmptyState from "@/components/EmptyState";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => { const r = await api.get("/notifications"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Inbox</div>
          <h1 className="text-4xl font-black tracking-tight">Notifications</h1>
        </div>
        <Button data-testid="mark-all-btn" variant="outline" onClick={async () => { await api.post("/notifications/read-all"); load(); }}>
          <CheckCheck size={14} className="mr-1" />Mark all read
        </Button>
      </div>

      {items.length === 0 ? <EmptyState icon={Bell} title="You're all caught up" description="Notifications will appear here as things happen." /> :
        <div className="border border-border rounded-md bg-card divide-y divide-border">
          {items.map((n) => (
            <div key={n.id} className={`px-4 py-3 ${!n.read ? "bg-accent/40" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-semibold text-sm">{n.title}</div>
                  <div className="text-xs text-muted-foreground">{n.message}</div>
                </div>
                <div className="font-mono text-[10px] text-muted-foreground">{fmtRelative(n.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}
